import { AvailabilityStatus } from './AvailabilityStatus';
import { JobPreference } from './JobPreference';
import { Language } from './Language';
import { Profile } from './Profile';
import { Relationship } from './Relationship';
import { SitterExperience } from './SitterExperience';
import { SitterRate } from './SitterRate';
import { SpecialExperience } from './SpecialExperience';
import { SpecialService } from './SpecialService';
import { SpecialSituation } from './SpecialSituation';
import { SitterStats } from './SitterStats';
import { TeachingSkill } from './TeachingSkill';

export interface Sitter extends Profile {
  about?: string;
  acceptingPayment?: boolean;
  acceptsAnyTime?: boolean;
  acceptsCreditCards?: boolean;
  acceptsFixedRates?: boolean;
  acceptsNewFamilies?: boolean;
  stats?: SitterStats;
  availabilityStatus?: AvailabilityStatus;
  backgroundCheck?: boolean;
  backgroundCheckDate?: string;
  badges?: Array<{
    type?: string;
    label?: string;
    description?: string;
    url?: string;
    icon?: string;
  }>;
  cancellationRate?: { label?: string };
  college?: {
    college?: { name?: string; url?: string; urlAlias?: string };
    graduation?: string;
    areaOfStudy?: { name?: string };
  };
  covidBadge?: { consented?: boolean };
  displayRate?: { minimumRate?: number; maximumRate?: number };
  certifications?: Array<{ id: number; name?: string; selected?: boolean }>;
  english?: string;
  experiences?: SitterExperience;
  expressedInterestInMyJobs?: boolean;
  familiesBookedCount?: number;
  hiddenReason?: number;
  homeSittingExperience?: string;
  jobPreferences?: JobPreference[];
  languages?: Language[];
  maxKids?: number;
  minimumHours?: number;
  paymentDisabled?: boolean;
  petSittingExperience?: string;
  rates?: SitterRate[];
  rating?: number;
  relationship?: Relationship;
  reliabilityPolicy?: string;
  repeatFamilies?: number;
  respondsQuicklyLabel?: string;
  responseTime?: number;
  latestReview?: { comment: string; vote: number; created: string };
  reviewCount?: number;
  seniorSittingExperience?: string;
  specialExperiences?: SpecialExperience[];
  specialServices?: SpecialService[];
  specialSituations?: SpecialSituation[];
  teachingSkills?: TeachingSkill[];
  /** @deprecated @see vimeoId */
  videoId?: string;
  vimeoId?: string;
  willSitCat?: boolean;
  willSitDog?: boolean;
  willSitHome?: boolean;
  willSitOtherPet?: boolean;
  willSitSenior?: boolean;
  willSitSingleFamily?: boolean;
  worksWithin?: number;
}

export enum WillSit {
  cat = 'Cat',
  dog = 'Dog',
  home = 'Home',
  otherPets = 'OtherPet',
  senior = 'Senior',
};

export type WillSitKey = keyof typeof WillSit;
